import { baseApi } from "./baseApi";

const VENDOR_QUOTATION_BASE_URL = "/vendor-quotation";

export const vendorQuotationApi = baseApi.injectEndpoints({
  tagTypes: ["VendorQuotation"],
  endpoints: (build) => ({
    addVendorQuotation: build.mutation({
      query: (body) => ({
        url: VENDOR_QUOTATION_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "VendorQuotation", id: "LIST" }],
    }),

    addVendorQuotationForPdfMail: build.mutation({
      query: (body) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/send-pdf-mail`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "VendorQuotation", id: "LIST" },
        { type: "Note", id: "LIST" },
      ],
    }),

    addVendorProfileQuotationForPdfMail: build.mutation({
      query: (body) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/send-vendor-profile-pdf-mail`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "VendorQuotation", id: "LIST" },
        { type: "Note", id: "LIST" },
      ],
    }),

    assignLeadToPdf: build.mutation({
      query: ({ id, vendorLead }) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/${id}/assign-leads`,
        method: "PATCH",
        body: { vendorLead },
      }),
      invalidatesTags: [{ type: "VendorQuotation", id: "LIST" }],
    }),

    listVendorQuotations: build.query({
      query: (params) => ({
        url: VENDOR_QUOTATION_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({
                type: "VendorQuotation",
                id: _id,
              })),
              { type: "VendorQuotation", id: "LIST" },
            ]
          : [{ type: "VendorQuotation", id: "LIST" }],
    }),

    getDDLVendorQuotationList: build.query({
      query: (params) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "VendorQuotation",
                id: _id,
              })),
              { type: "VendorQuotation", id: "DDL" },
            ]
          : [{ type: "VendorQuotation", id: "DDL" }],
    }),

    getVendorQuotationDetail: build.query({
      query: (id) => `${VENDOR_QUOTATION_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "VendorQuotation", id },
        { type: "VendorQuotation", id: "LIST" },
      ],
    }),

    updateVendorQuotation: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "VendorQuotation", id },
        { type: "VendorQuotation", id: "LIST" },
      ],
    }),

    searchVendorQuotations: build.query({
      query: ({ q }) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/search`,
        params: { q },
      }),
    }),
    getVendorQuotationsByLead: build.query({
      query: (vendorLeadId) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/by-lead/${vendorLeadId}`,
      }),
      providesTags: [{ type: "VendorQuotation", id: "BY_LEAD" }],
    }),
    getVendorProfileQuotationList: build.query({
      query: (params) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/list-vendor-profile-quotation`,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "VendorProfileQuotation", id: "LIST" }],
    }),
    getVendorProfileQuotationsByProfile: build.query({
      query: ({ vendorProfileId, page, limit }) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/${vendorProfileId}/vendor-quotation`,
        method: "GET",
        params: { page, limit },
      }),
      providesTags: [{ type: "VendorProfileQuotation", id: "LIST" }],
    }),
    getVendorProfileQuotationsByProfileCount: build.query({
      query: ({ vendorProfileId, page, limit }) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/${vendorProfileId}/vendor-quotation-count`,
        method: "GET",
        params: { page, limit },
      }),
      providesTags: [{ type: "VendorProfileQuotation", id: "LIST" }],
    }),
    exportVendorProfileQuotationList: build.query({
      query: (params) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/export-vendor-profile-quotation`,
        method: "GET",
        params,
      }),
    }),
    listAllVendorQuotation: build.query({
      query: (params) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/list-all-quotation`,
        method: "GET",
        params,
      }),
    }),
    exportAllVendorQuotation: build.query({
      query: (params) => ({
        url: `${VENDOR_QUOTATION_BASE_URL}/export-list-all-quotation`,
        method: "GET",
        params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddVendorQuotationMutation,
  useAddVendorQuotationForPdfMailMutation,
  useListVendorQuotationsQuery,
  useLazyListVendorQuotationsQuery,
  useLazyGetDDLVendorQuotationListQuery,
  useGetVendorQuotationDetailQuery,
  useUpdateVendorQuotationMutation,
  useLazySearchVendorQuotationsQuery,
  useAssignLeadToPdfMutation,
  useLazyGetVendorQuotationsByLeadQuery,
  useAddVendorProfileQuotationForPdfMailMutation,
  useLazyGetVendorProfileQuotationListQuery,
  useLazyGetVendorProfileQuotationsByProfileQuery,
  useLazyGetVendorProfileQuotationsByProfileCountQuery,
  useLazyExportVendorProfileQuotationListQuery,
  useLazyListAllVendorQuotationQuery,
  useLazyExportAllVendorQuotationQuery,
} = vendorQuotationApi;
